import { __export } from './chunk-7P6ASYW6.mjs';

// constants/offerings.ts
var offerings_exports = {};
__export(offerings_exports, {
  ACCREDITED_ONLY_EXEMPTIONS: () => ACCREDITED_ONLY_EXEMPTIONS,
  COMMON_STOCK_TYPE: () => COMMON_STOCK_TYPE,
  CONVERTIBLE_NOTE_STOCK_TYPE: () => CONVERTIBLE_NOTE_STOCK_TYPE,
  EXEMPTION_OPTIONS: () => EXEMPTION_OPTIONS,
  EXEMPTION_TYPES: () => EXEMPTION_TYPES,
  EXEMPTION_TYPE_DISPLAY: () => EXEMPTION_TYPE_DISPLAY,
  INCOME_COLLECTING_EXEMPTIONS: () => INCOME_COLLECTING_EXEMPTIONS,
  INVESTOR_TYPE_DISPLAY: () => INVESTOR_TYPE_DISPLAY,
  IN_LIEU_OF_CASH_STOCK_TYPE: () => IN_LIEU_OF_CASH_STOCK_TYPE,
  OFFERING_STATUS_LIST: () => OFFERING_STATUS_LIST,
  PREFERRED_STOCK_TYPE: () => PREFERRED_STOCK_TYPE,
  REGULATIONS: () => REGULATIONS,
  REGULATION_A: () => REGULATION_A,
  REGULATION_A_PLUS: () => REGULATION_A_PLUS,
  REGULATION_CF: () => REGULATION_CF,
  REGULATION_D: () => REGULATION_D,
  REGULATION_S: () => REGULATION_S,
  RULES: () => RULES,
  RULE_504B: () => RULE_504B,
  RULE_506B: () => RULE_506B,
  RULE_506C: () => RULE_506C,
  SAFE_STOCK_TYPE: () => SAFE_STOCK_TYPE,
  SECTION_4A5: () => SECTION_4A5,
  SELF_UNDERWRITTEN: () => SELF_UNDERWRITTEN,
  STATUS: () => STATUS,
  STOCK_TYPE_OPTIONS: () => STOCK_TYPE_OPTIONS,
  StockTypeMap: () => StockTypeMap,
  TIERS: () => TIERS,
  TIER_1: () => TIER_1,
  TIER_2: () => TIER_2,
  UNIT_STOCK_TYPE: () => UNIT_STOCK_TYPE
});
var REGULATION_A = "Regulation A";
var REGULATION_A_PLUS = "Regulation A+";
var REGULATION_D = "Regulation D";
var REGULATION_S = "Regulation S";
var REGULATION_CF = "Regulation CF";
var SECTION_4A5 = "Section 4(a)(5)";
var SELF_UNDERWRITTEN = "Self-Underwritten";
var RULE_504B = "Rule 504(b)";
var RULE_506B = "Rule 506(b)";
var RULE_506C = "Rule 506(c)";
var TIER_1 = "Tier 1";
var TIER_2 = "Tier 2";
var EXEMPTION_TYPES = {
  REG_A: "REG_A",
  REG_A_PLUS: "REG_A_PLUS",
  REG_D_504_B: "REG_D_504_B",
  REG_D_506_B: "REG_D_506_B",
  REG_D_506_C: "REG_D_506_C",
  REG_S: "REG_S",
  REGULATION_CF: "REGULATION_CF",
  SECTION_4A5: "SECTION_4A5",
  SELF_UNDERWRITTEN: "SELF_UNDERWRITTEN",
  IPO: "IPO"
};
var ACCREDITED_ONLY_EXEMPTIONS = [
  EXEMPTION_TYPES.REG_D_506_B,
  EXEMPTION_TYPES.REG_D_504_B,
  EXEMPTION_TYPES.REGULATION_CF,
  EXEMPTION_TYPES.SECTION_4A5,
  EXEMPTION_TYPES.SELF_UNDERWRITTEN
];
var INCOME_COLLECTING_EXEMPTIONS = [EXEMPTION_TYPES.REG_A, EXEMPTION_TYPES.REG_A_PLUS, EXEMPTION_TYPES.IPO];
var TIERS = {
  TIER_1,
  TIER_2
};
var RULES = {
  RULE_504B,
  RULE_506B,
  RULE_506C
};
var REGULATIONS = {
  REGULATION_A,
  REGULATION_A_PLUS,
  REGULATION_D,
  REGULATION_S,
  REGULATION_CF
};
var STATUS = {
  DRAFT: "DRAFT",
  IN_REVIEW: "IN_REVIEW",
  ACTIVE: "ACTIVE",
  CLOSED: "CLOSED",
  TERMINATED: "TERMINATED"
};
var OFFERING_STATUS_LIST = ["DRAFT", "IN_REVIEW", "ACTIVE", "CLOSED", "TERMINATED"];
var COMMON_STOCK_TYPE = "common_stock";
var CONVERTIBLE_NOTE_STOCK_TYPE = "convertible_note";
var PREFERRED_STOCK_TYPE = "preferred_stock";
var UNIT_STOCK_TYPE = "unit";
var SAFE_STOCK_TYPE = "safe";
var IN_LIEU_OF_CASH_STOCK_TYPE = "in_lieu_of_cash";
var StockTypeMap = {
  [COMMON_STOCK_TYPE]: "Common Stock",
  [CONVERTIBLE_NOTE_STOCK_TYPE]: "Convertible Notes",
  [PREFERRED_STOCK_TYPE]: "Preferred Stock",
  [UNIT_STOCK_TYPE]: "Units",
  [SAFE_STOCK_TYPE]: "SAFE",
  [IN_LIEU_OF_CASH_STOCK_TYPE]: "In Lieu of Cash"
};
var EXEMPTION_TYPE_DISPLAY = {
  REG_A: "Regulation A",
  REG_A_PLUS: "Regulation A+",
  REG_D_504_B: "Regulation D - Rule 504(b)",
  REG_D_506_B: "Regulation D - Rule 506(b)",
  REG_D_506_C: "Regulation D - Rule 506(c)",
  REG_S: "Regulation S",
  REGULATION_CF: "Regulation CF",
  SECTION_4A5: "Section 4(a)(5)",
  SELF_UNDERWRITTEN: "Self-Underwritten",
  IPO: "Initial Public Offering"
};
var INVESTOR_TYPE_DISPLAY = {
  INDIVIDUAL: "Individual",
  JOINT: "Joint",
  ENTITY: "Entity",
  TRUST: "Trust"
};
var EXEMPTION_OPTIONS = Object.entries(EXEMPTION_TYPE_DISPLAY).map(([value, label]) => ({
  value,
  label
}));
var STOCK_TYPE_OPTIONS = Object.entries(StockTypeMap).map(([value, label]) => ({
  value,
  label
}));

export { ACCREDITED_ONLY_EXEMPTIONS, COMMON_STOCK_TYPE, CONVERTIBLE_NOTE_STOCK_TYPE, EXEMPTION_OPTIONS, EXEMPTION_TYPES, EXEMPTION_TYPE_DISPLAY, INCOME_COLLECTING_EXEMPTIONS, INVESTOR_TYPE_DISPLAY, IN_LIEU_OF_CASH_STOCK_TYPE, OFFERING_STATUS_LIST, PREFERRED_STOCK_TYPE, REGULATIONS, REGULATION_A, REGULATION_A_PLUS, REGULATION_CF, REGULATION_D, REGULATION_S, RULES, RULE_504B, RULE_506B, RULE_506C, SAFE_STOCK_TYPE, SECTION_4A5, SELF_UNDERWRITTEN, STATUS, STOCK_TYPE_OPTIONS, StockTypeMap, TIERS, TIER_1, TIER_2, UNIT_STOCK_TYPE, offerings_exports };
